<template>
    <Layout header-class="header-left-align" nav-alignment="left">
			<div class="top-page"
					 :style="{'background-image': `url(${require(`@/assets/images/partner-banner.png`)})`}">
				<h2 class="banner-title">产品服务</h2>
				<p class="banner-note">共研 · 共创 · 共守</p>
				<p class="banner-info">Isafeclub LIMITED 面向交易所、公链项目、DeFi 协议、钱包厂商，提供定制化全链路 Web3 安全审计与应急处置服务。</p>
			</div>

			<!-- 业务总览 -->
			<section class="module service-overview">
				<div class="center70">
					<div class="module-title">
						<h2 class="title">核心业务 <span class="en">SERVICES</span></h2>
					</div>
					<p class="overview-desc">
						iSafeClub 践行“共研、共创、共守”的 Web3 安全生态准则，覆盖智能合约审计、跨链漏洞排查、交易所风控架构整改、黑客攻击事后溯源修复、链上资产被盗追回方案定制等全链路服务。以下四大业务板块为平台核心收入来源。
					</p>
					<div class="overview-grid">
						<div class="overview-card">
							<span class="ov-num">01</span>
							<h3>定制化 Web3 安全项目服务</h3>
							<p>面向机构的全链路定制化安全审计与应急处置项目</p>
						</div>
						<div class="overview-card">
							<span class="ov-num">02</span>
							<h3>SaaS 软件订阅</h3>
							<p>云端自动化漏洞扫描、链上监控与风控控制台</p>
						</div>
						<div class="overview-card">
							<span class="ov-num">03</span>
							<h3>安全软件及硬件销售</h3>
							<p>商用安全软件与企业级 Web3 安全硬件设备</p>
						</div>
						<div class="overview-card">
							<span class="ov-num">04</span>
							<h3>年度会员订阅</h3>
							<p>分级会员权益体系，覆盖个人开发者与企业机构</p>
						</div>
					</div>
				</div>
			</section>

			<!-- （一）定制化项目服务 -->
			<section class="module block-gray">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">一</span>
						<h2 class="title">定制化 Web3 安全项目服务费</h2>
					</div>
					<p class="sec-lead">
						面向交易所、公链项目、DeFi 协议、钱包厂商，提供定制化全链路安全审计与应急处置项目服务，覆盖智能合约审计、跨链漏洞排查、风控架构整改、黑客攻击事后溯源修复、链上资产被盗追回方案定制。
					</p>

					<h3 class="sub-title">服务场景</h3>
					<div class="scene-list">
						<div class="scene-item">
							<img src="@/assets/images/icons/安全漏洞攻击模拟.png">
							<div>
								<div class="scene-title">大型交易所专项安全项目</div>
								<div class="scene-desc">对标 Bybit 15 亿美元盗案同类交易所全流程防护定制项目。</div>
							</div>
						</div>
						<div class="scene-item">
							<img src="@/assets/images/icons/EVM链重入攻击防护实战.png">
							<div>
								<div class="scene-title">公链 / 协议漏洞修复定制</div>
								<div class="scene-desc">Mode Ionic 平台遭攻击类项目，提供合约重入漏洞、权限漏洞专项整改开发。</div>
							</div>
						</div>
						<div class="scene-item">
							<img src="@/assets/images/icons/安全标准提案.png">
							<div>
								<div class="scene-title">长期安全顾问定制</div>
								<div class="scene-desc">峰会、数字资产机构长期安全顾问定制项目，含年度安全巡检、攻防模拟演练。</div>
							</div>
						</div>
					</div>

					<div class="fee-note">
						<h3 class="sub-title">收费机制公示</h3>
						<p>
							按项目人天、资产规模、审计深度分级报价：基础合约审计包干价、大型机构年度安全顾问打包服务费、盗案应急处置按涉案资产比例收取项目服务费，合同落地后一次性 / 分期结算。
						</p>
					</div>
				</div>
			</section>

			<!-- （二）SaaS 订阅 -->
			<section class="module">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">二</span>
						<h2 class="title">SaaS 软件订阅收入</h2>
					</div>
					<p class="sec-lead">
						面向个人开发者、项目团队、企业机构提供云端自动化安全工具，包含漏洞扫描、链上监控、风控预警三大 SaaS 系统。
					</p>

					<div class="feature-cards">
						<div class="feature-card">
							<img src="@/assets/images/icons/漏洞扫描工具.png">
							<h3>链上漏洞扫描 SaaS 平台</h3>
							<p>自动化检测 EVM / 多链智能合约漏洞，内置重入攻击、权限溢出检测引擎。</p>
						</div>
						<div class="feature-card">
							<img src="@/assets/images/icons/链上监控脚本.png">
							<h3>7×24 链上监控脚本系统</h3>
							<p>实时监测大额转账、恶意合约部署、钱包异常授权。</p>
						</div>
						<div class="feature-card">
							<img src="@/assets/images/icons/节点安全.png">
							<h3>企业级 Web3 风控控制台</h3>
							<p>交易所、钱包商户接入，实时拦截黑客地址、洗钱交互。</p>
						</div>
					</div>

					<div class="sub-plans">
						<h3 class="sub-title">订阅收费模式</h3>
						<ul class="plain-list">
							<li><strong>基础版（个人开发者）</strong>：月度订阅 / 年度订阅。</li>
							<li><strong>企业标准版（中小 DeFi 项目）</strong>：按链上账户数量阶梯订阅。</li>
							<li><strong>旗舰定制版（交易所、头部公链）</strong>：专属私有部署 SaaS 年费订阅，含专属运维支持。</li>
						</ul>
					</div>
				</div>
			</section>

			<!-- （三）软件硬件销售 -->
			<section class="module block-gray">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">三</span>
						<h2 class="title">安全软件及硬件销售收入</h2>
					</div>

					<div class="hw-grid">
						<div class="hw-col">
							<h3 class="sub-title">软件产品</h3>
							<p>开源商用漏洞扫描工具、链上安全监测客户端、离线合约审计工具包，支持永久授权买断 + 年度升级服务费两种模式。</p>
							<ul class="tag-list">
								<li>漏洞扫描工具</li>
								<li>链上监测客户端</li>
								<li>离线审计工具包</li>
							</ul>
						</div>
						<div class="hw-col">
							<h3 class="sub-title">安全硬件产品</h3>
							<p>Web3 节点加密安全硬件、私钥隔离防护硬件钱包、企业离线签名安全设备。官网增设「安全硬件商城」子页面，展示硬件参数、采购报价、批量采购方案。</p>
							<ul class="tag-list">
								<li>节点加密硬件</li>
								<li>硬件钱包</li>
								<li>离线签名设备</li>
							</ul>
						</div>
					</div>
					<div class="fee-note">
						<h3 class="sub-title">收入说明</h3>
						<p>硬件一次性销售 + 后续硬件固件升级、维保年费；软件一次性授权买断收入。</p>
					</div>
				</div>
			</section>

			<!-- （四）会员订阅 -->
			<section class="module">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">四</span>
						<h2 class="title">年度会员订阅收入</h2>
					</div>
					<p class="sec-lead">依托官网技术社群、会员成果体系设置分级会员方案，免费会员为基础体验，付费会员为核心收入。</p>

					<div class="member-tier-list">
						<div class="tier-card">
							<div class="tier-head free">普通会员</div>
							<div class="tier-body">
								<p class="tier-price">免费</p>
								<ul>
									<li>行业新闻阅览</li>
									<li>公开安全报告阅览</li>
								</ul>
							</div>
						</div>
						<div class="tier-card">
							<div class="tier-head pro">专业个人会员</div>
							<div class="tier-body">
								<p class="tier-price">年度订阅</p>
								<ul>
									<li>漏洞工具试用</li>
									<li>线上研讨会回放</li>
									<li>基础技术文档</li>
								</ul>
							</div>
						</div>
						<div class="tier-card featured">
							<div class="tier-head elite">企业精英会员</div>
							<div class="tier-body">
								<p class="tier-price">年度订阅 · 核心权益</p>
								<ul>
									<li>专属 Telegram 会员技术群</li>
									<li>一对一安全咨询</li>
									<li>线下攻防实战培训</li>
									<li>专利 / 白皮书优先查阅</li>
									<li>免费漏洞模拟演练</li>
									<li>全球办公室线下技术沙龙资格</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="fee-note">
						<h3 class="sub-title">收费公示</h3>
						<p>分个人年付、企业单位年付两档定价，支持对公转账、合约年费续签，开具合规商业票据。</p>
					</div>
				</div>
			</section>
    </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'

    export default {
        name: 'Service',
        components: {Layout},
        data() {
            return {}
        }
    }
</script>
<style scoped lang="scss">
.title {
	font-weight: 700;
	position: relative;
	font-size: 28px;
}
span.en {
	font-size: 32px;
	color: #0d6efd;
	padding-left: 5px;
}
.block-gray {
	background-color: #f4f4f4;
}
.service-overview {
	.overview-desc {
		font-size: 16px;
		line-height: 2;
		color: #4d4d4d;
		margin: 20px 0 40px;
	}
	.overview-grid {
		display: flex;
		gap: 24px;
		.overview-card {
			flex: 1;
			background: linear-gradient(160deg, #0b1b46 0%, #070a2b 100%);
			border-radius: 12px;
			padding: 32px 24px;
			color: #fff;
			transition: .4s;
			.ov-num {
				font-size: 30px;
				font-weight: 800;
				color: #0d6efd;
			}
			h3 {
				font-size: 20px;
				font-weight: 700;
				margin: 16px 0 12px;
				color: #fff;
			}
			p {
				font-size: 14px;
				color: #b6bbd4;
				line-height: 1.7;
			}
			&:hover {
				transform: translateY(-8px);
			}
		}
	}
}
.section-head {
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 20px;
	.sec-index {
		width: 44px;
		height: 44px;
		flex-shrink: 0;
		border-radius: 50%;
		background-color: #0d6efd;
		color: #fff;
		font-size: 22px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
.sec-lead {
	font-size: 16px;
	line-height: 2;
	color: #4d4d4d;
	margin-bottom: 30px;
}
.sub-title {
	font-size: 20px;
	font-weight: 700;
	margin: 30px 0 20px;
	padding-left: 12px;
	position: relative;
	&:after {
		content: "";
		position: absolute;
		height: 70%;
		width: 4px;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		background-color: #0d6efd;
	}
}
.scene-list {
	display: flex;
	flex-direction: column;
	gap: 16px;
	.scene-item {
		display: flex;
		align-items: center;
		gap: 20px;
		background: #fff;
		padding: 20px 24px;
		border-radius: 10px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, .05);
		transition: .4s;
		img {
			width: 54px;
			height: 54px;
			flex-shrink: 0;
		}
		.scene-title {
			font-size: 18px;
			font-weight: 700;
			margin-bottom: 6px;
		}
		.scene-desc {
			font-size: 14px;
			color: grey;
			line-height: 1.6;
		}
		&:hover {
			transform: translateX(8px);
		}
	}
}
.fee-note {
	margin-top: 20px;
	p {
		font-size: 16px;
		line-height: 2;
		color: #4d4d4d;
	}
}
.feature-cards {
	display: flex;
	gap: 24px;
	margin-top: 20px;
	.feature-card {
		flex: 1;
		background: #fff;
		border: 1px solid #eee;
		border-radius: 12px;
		padding: 32px 24px;
		text-align: center;
		transition: .4s;
		img {
			width: 64px;
			height: 64px;
			margin-bottom: 20px;
		}
		h3 {
			font-size: 18px;
			font-weight: 700;
			margin-bottom: 12px;
		}
		p {
			font-size: 14px;
			color: grey;
			line-height: 1.7;
		}
		&:hover {
			transform: translateY(-8px);
			box-shadow: 0 10px 30px rgba(13, 110, 253, .12);
		}
	}
}
.plain-list {
	padding-left: 0;
	li {
		font-size: 16px;
		line-height: 2;
		color: #4d4d4d;
		padding-left: 20px;
		position: relative;
		&:before {
			content: "";
			position: absolute;
			left: 0;
			top: 14px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: #0d6efd;
		}
	}
}
.hw-grid {
	display: flex;
	gap: 40px;
	margin-top: 10px;
	.hw-col {
		flex: 1;
		background: #fff;
		border-radius: 12px;
		padding: 10px 30px 30px;
		p {
			font-size: 15px;
			line-height: 1.9;
			color: #4d4d4d;
		}
		.tag-list {
			display: flex;
			flex-wrap: wrap;
			gap: 12px;
			padding-left: 0;
			margin-top: 16px;
			li {
				background: #eef4ff;
				color: #0d6efd;
				font-size: 14px;
				padding: 6px 16px;
				border-radius: 20px;
			}
		}
	}
}
.member-tier-list {
	display: flex;
	gap: 24px;
	margin-top: 10px;
	.tier-card {
		flex: 1;
		border-radius: 12px;
		overflow: hidden;
		border: 1px solid #eee;
		background: #fff;
		&.featured {
			border-color: #0d6efd;
			box-shadow: 0 10px 30px rgba(13, 110, 253, .15);
		}
		.tier-head {
			padding: 20px;
			text-align: center;
			font-size: 20px;
			font-weight: 700;
			color: #fff;
			&.free { background-color: #6c757d; }
			&.pro { background-color: #0d6efd; }
			&.elite { background: linear-gradient(120deg, #0b1b46, #0d6efd); }
		}
		.tier-body {
			padding: 24px;
			.tier-price {
				font-size: 16px;
				font-weight: 700;
				color: #0d6efd;
				margin-bottom: 16px;
				text-align: center;
			}
			ul {
				padding-left: 0;
				li {
					font-size: 14px;
					color: #4d4d4d;
					line-height: 1.6;
					padding: 8px 0 8px 20px;
					position: relative;
					border-bottom: 1px dashed #eee;
					&:before {
						content: "";
						position: absolute;
						left: 0;
						top: 15px;
						width: 6px;
						height: 6px;
						border-radius: 50%;
						background-color: #0d6efd;
					}
				}
			}
		}
	}
}
@media screen and (max-width: 850px) {
	.service-overview .overview-grid,
	.feature-cards,
	.hw-grid,
	.member-tier-list {
		flex-direction: column;
	}
	.title {
		font-size: 20px;
	}
	span.en {
		font-size: 16px;
	}
	.scene-list .scene-item {
		align-items: flex-start;
	}
}
</style>
